export class BaseInstrument {
    constructor() {
        this.oscillator = null;
    }
    // Stop any sustained (indefinite) note.
    stop(audioContext) {
        if (this.oscillator) {
            this.oscillator.stop();
            this.oscillator.disconnect();
            this.oscillator = null;
        }
    }
}
